import { render, staticRenderFns } from "./GroupDelete.vue?vue&type=template&id=258a2394&scoped=true"
import script from "./GroupDelete.vue?vue&type=script&lang=js"
export * from "./GroupDelete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "258a2394",
  null
  
)

export default component.exports